import { ActivityId } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'

export const useActivity = (id?: ActivityId) => {
  const client = useGyymClient()
  return useGyymSWR(id ? [client.user.activities.get, id] : null)
}
